module.exports = __webpack_public_path__ + "media/43.d61152f0.mp3";